import { Divider, Flex, HStack } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { useToast } from "@chakra-ui/react";
import { ReactComponent as LeftIcon } from "../../assets/chevron-left.svg";
import { ReactComponent as RightIcon } from "../../assets/chevron-right.svg";
import useLegacyIframeResizeMessage from "../../hooks/useLegacyIframeResizeMessage";
import schema from "../../validation/bookeeSchema";
import { buildSchema } from "../../validation/bookeeSchema";
import { useJourneyContext } from "../../hooks/useJourney";
import Heading from "../../Components/Text/Heading";
import SmallContainer from "../../Components/Container/SmallContainer";
import Slots from "../../Components/Slots/Slots";
import CustomButton from "../../Components/Button/CustomButton";
import SubHeading from "../../Components/Text/SubHeading";
import Form from "../../Components/Forms/Form";
import LargeContainer from "../../Components/Container/LargeContainer";
import Calendar from "../../Components/Calendar/Calendar";
import {
  addBooking,
  getMonthlyData,
  getEffectiveBookingWindow,
} from "../../bookingapi/booking.operations";
import { getDailyRecords } from "../../utils/DailyRecords";
import LoadingScreen from "../../Components/LoadingScreen/LoadingScreen";
import useFormConfig from "../../hooks/useFormConfig";
const dayLabels = [
    { "name": "mon", "abbreviation": "mon" },
    { "name": "tue", "abbreviation": "tue" },
    { "name": "wed", "abbreviation": "wed" },
    { "name": "thu", "abbreviation": "thu" },
    { "name": "fri", "abbreviation": "fri" },
    { "name": "sat", "abbreviation": "sat" },
    { "name": "sun", "abbreviation": "sun" }
  ]

export function findNearestDate(dates) {
  const currentDate = new Date();
  // Calculate the time difference between each date in the array and the current date
  const timeDifferences = dates.map((date) => Math.abs(date - currentDate));
  // Find the index of the date with the smallest time difference
  const nearestDateIndex = timeDifferences.indexOf(
    Math.min(...timeDifferences)
  );
  // Return the nearest date
  const nearestDate = dates[nearestDateIndex];
  return nearestDate;
}

export default function AddBookingPage() {
  useLegacyIframeResizeMessage();
  const location = useLocation();
  const navigate = useNavigate();
  const { formConfig } = useFormConfig();

  const { appId } = useJourneyContext();
  // TODO: combine form states
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [calendarDate, setCalendarDate] = useState(new Date());
  const [selectedDate, setSelectedDate] = useState(null);
  const [monthlyData, setMonthlyData] = useState([]);
  const [dailyData, setDailyData] = useState([]);
  const [selectedSlot, setSelectedSlot] = useState({});
  const [loader, setLoader] = useState(true);
  const toast = useToast();

  const year = calendarDate.getFullYear();
  const month = calendarDate.getMonth() + 1;

  const {
    reference,
    customerFirstName,
    customerLastName,
    phoneNumber,
    emailAddress,
    customerConsent,
    notes,
    preRegToken,
    bookingWindow: navBookingWindow
  } = location?.state || {};

  const [bookingWindow, setBookingWindow] = useState(navBookingWindow || null);

  useEffect(() => {
    updateMonthlyData();
    // Fetch fresh effective booking window with user data
    if (customerFirstName || reference) {
      const userData = { customerFirstName, customerLastName, phoneNumber, emailAddress, reference };
      getEffectiveBookingWindow(userData).then((window) => {
        if (window) setBookingWindow(window);
      });
    }
  }, []);

  useEffect(() => {
    if (selectedDate) {
      const year = selectedDate.getFullYear();
      const month = selectedDate.getMonth() + 1; // Add 1 to get the month number starting from 1 instead of 0
      const day = selectedDate.getDate();

      getDailyRecords(day, month, year, setDailyData);
    }
  }, [selectedDate]);

  // END OF HOOKS

  if (location.state === null) {
    return navigate("/");
  }

  const handleSubmit = async (event) => {
    // TODO: lock down ui so these cant be hit
    if (!selectedDate || selectedDate === "") {
      toast({
        title: "Please select a date",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }

    if (!selectedSlot || selectedSlot === "") {
      toast({
        title: "Please select a time slot",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }

    try {
      // TODO: abstract out date formatters
      let date = `${selectedDate.getFullYear()}-${(selectedDate.getMonth() + 1)
        .toString()
        .padStart(2, "0")}-${selectedDate
        .getDate()
        .toString()
        .padStart(2, "0")}`;

      let body = {
        bookingDate: date,
        bookingTimeSlot: selectedSlot.timeSlotId,
        status: "BOOKED",
        customerFirstName,
        customerLastName,
        phoneNumber,
        emailAddress,
        reference,
        appId,
        customerConsent,
        notes,
        ...(preRegToken && { preRegToken })
      };

      const response = await addBooking(body);

      if (response?.data?.status === "success") {
        navigate(`/booking-confirmed?token=${response.data.token}`, {
          state: {
            showAmendButton: true,
            selectedSlot,
            selectedDate,
            phoneNumber,
            emailAddress,
          },
          replace: true,
        });
        // TODO: how much of this reset stuff is neccessary
        setSelectedSlot("");
      } else {
        if (response.data === "Slot not found") {
          toast({
            title: "Slot not found",
            status: "error",
            duration: 3000,
            isClosable: true,
          });
          return;
        } else if (response?.data?.reason === "Booking already found") {
          toast({
            title: "Booking already found",
            status: "error",
            duration: 3000,
            isClosable: true,
          });
          return;
        } else if (
          response?.data?.reason === "Booking not available for this date"
        ) {
          toast({
            title: "Booking not availible for this date.",
            status: "error",
            duration: 3000,
            isClosable: true,
          });
          return;
        } else {
          toast({
            title: "Something went wrong",
            description: "Please try again later",
            status: "error",
            duration: 3000,
            isClosable: true,
          });
          return;
        }
      }
    } catch (error) {
      toast({
        title: "Something went wrong",
        description: "Please try again later",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      throw error;
    }
  };

  // TODO: combine/refactor makeBooking and handleSubmit
  function makeBooking(event) {
    event.preventDefault();
    if (isLoading) return;
    setIsLoading(true);

    const activeSchema = formConfig ? buildSchema(formConfig) : schema;

    activeSchema
      .validate(
        {
          customerFirstName,
          customerLastName,
          phoneNumber,
          emailAddress,
          reference,
          customerConsent,
          notes
        },
        { abortEarly: false }
      )
      .then(() => handleSubmit())
      .catch((validationErrors) => {
        // Validation failed, set the errors state variable
        const errors = {};
        validationErrors.inner.forEach((error) => {
          errors[error.path] = error.message;
        });
        setErrors(errors);
      })
      .finally(() => setIsLoading(false));
  }

  async function updateMonthlyData(newYear = year, newMonth = month) {
    try {
      setLoader(true);
      const data = await getMonthlyData(newYear, newMonth);
      setMonthlyData(data);
    } catch (err) {
      console.log(err);
    } finally {
      setLoader(false);
    }
  }

  function subtractMonth() {
    const newDate = new Date(
      calendarDate.setMonth(calendarDate.getMonth() - 1)
    );
    setCalendarDate(newDate);
    updateMonthlyData(newDate.getFullYear(), newDate.getMonth() + 1);
  }
  function addMonth() {
    const newDate = new Date(
      calendarDate.setMonth(calendarDate.getMonth() + 1)
    );
    setCalendarDate(newDate);
    updateMonthlyData(newDate.getFullYear(), newDate.getMonth() + 1);
  }

  function isDateOpen(day) {
    const dayData = monthlyData?.find((d) => d.date.split("-")[2] == day);
    if (!dayData?.open) return false;
    if (dayData.availableSlots <= 0) return false;

    // Apply user-specific booking window constraints (may differ from server's generic window)
    if (bookingWindow) {
      const date = new Date(year, month - 1, day);
      date.setHours(0, 0, 0, 0);
      if (bookingWindow.start) {
        const start = new Date(bookingWindow.start);
        start.setHours(0, 0, 0, 0);
        if (date < start) return false;
      }
      if (bookingWindow.end) {
        const end = new Date(bookingWindow.end);
        end.setHours(23, 59, 59, 999);
        if (date > end) return false;
      }
    }

    return true;
  }

  function getAvailableSlotsForDay(day) {
    // console.log("this is monthly data", monthlyData);
    // Find the corresponding day data in the monthlyData array
    const dayData = monthlyData?.find((d) => d.date.split("-")[2] == day);
    // If dayData exists, return the availableSlots, otherwise return 0
    const slots = dayData ? dayData?.availableSlots - dayData?.bookedSlots : 0;
    // given customer visibile app, mask possible negative slots.
    return slots > 0 ? slots : 0;
  }

  function renderDays() {
    // Get today's date
    let today = new Date();
    // Make sure to set the time to midnight for a fair comparison
    today.setHours(0, 0, 0, 0);

    return (
      <>
        {loader ? (
          <LoadingScreen
            loadingText={"Hold tight"}
            loadingSubText={"It will just take a few moments"}
          />
        ) : (
          <Calendar
            isDateOpen={isDateOpen}
            getAvailableSlotsForDay={getAvailableSlotsForDay}
            selectedDate={selectedDate}
            setSelectedDate={setSelectedDate}
            calendarDate={calendarDate}
          />
        )}
      </>
    );
  }

  const formattedDate = ` ${calendarDate.toLocaleString("default", {
    month: "long",
  })} ${calendarDate.getFullYear()}`;

  return (
    <LargeContainer minH={"100vh"}>
      <SmallContainer
        px={{ base: "2%"}}
        maxW="1200px"
        margin="0 auto"
      >
        <SmallContainer
          py={"30px"}
          minHeight="714px"
          justifyContent="space-between"
          flexDirection={{ base: "column", md: "row" }}
        >
          <SmallContainer
            width={{ base: "100%", md: "49.14%" }}
            backgroundColor={"#FFFFFF"}
            alignItems={"center"}
          >
            <Form
              errors={errors}
              formData={{
                reference,
                customerFirstName,
                customerLastName,
                phoneNumber,
                emailAddress,
                notes
              }}
              formConfig={formConfig}
              disabled
              displayedUIForm
            />

            <Flex
              width={"92.92%"}
              justifyContent={"center"}
              minHeight={"384px"}
            >
              <Flex width={"100%"} flexDirection={"column"}>
                <Flex width={"100%"} minheight={"80px"}>
                  <Flex marginTop={"27px"}>
                    <LeftIcon
                      style={{
                        cursor: "pointer",
                      }}
                      onClick={subtractMonth}
                    />
                    &nbsp;
                    <RightIcon
                      style={{
                        cursor: "pointer",
                      }}
                      onClick={addMonth}
                    />
                  </Flex>
                  <Heading headingLabel={formattedDate} />
                </Flex>
                <HStack spacing="1.26%" marginTop={"16px"}>
                  {dayLabels.map((day, index) => (
                    <SubHeading
                      key={index}
                      textAlign={"center"}
                      w="13.2%"
                      h="16px"
                      subHeadingLabel={day.abbreviation}
                    ></SubHeading>
                  ))}
                </HStack>
                <Flex marginTop={"8px"} marginBottom="16px">
                  {renderDays()}
                </Flex>
              </Flex>
            </Flex>
          </SmallContainer>

          <SmallContainer
            mt={{ base: "20px", md: "0px" }}
            width={{ base: "100%", md: "49.14%" }}
            backgroundColor={"#FFFFFF"}
            alignItems={"center"}
            justifyContent={"space-between"}
          >
            <SmallContainer width={"92.92%"}>
              {selectedDate && (
                <>
                  <Heading headingLabel="Choose your time slot"></Heading>
                  <Flex width={"23.81%"} marginTop={"10px"}>
                    <SubHeading subHeadingLabel="Available Slots" />
                  </Flex>
                  <Slots
                    dailyData={dailyData}
                    selectedSlot={selectedSlot}
                    setSelectedSlot={setSelectedSlot}
                    selectedDate={selectedDate}
                  ></Slots>
                </>
              )}
            </SmallContainer>

            <SmallContainer minHeight={"104px"}>
              <Divider />

              {selectedDate && selectedSlot.timeSlotId && (
                <CustomButton
                  onClick={makeBooking}
                  marginTop={"32px"}
                  buttonLabel="Confirm Booking"
                  isDisabled={isLoading}
                  isLoading={isLoading}
                ></CustomButton>
              )}
            </SmallContainer>
          </SmallContainer>
        </SmallContainer>
      </SmallContainer>
    </LargeContainer>
  );
}
